<ng-container *ngIf="showStats">
  <div class="d-flex no-select cursor-pointer" [routerLink]="['/home']">
    <!-- <li class="nav-item d-none d-lg-flex align-items-center mr-1">
      <div class="navbar-stats-badge">
        <span class="stat-item">
          <i class="feather icon-monitor stat-icon online-icon"></i>
          <span class="stat-value">24,532</span>
          <span class="stat-label">Online</span>
        </span>
        <span class="stat-divider"></span>
        <span class="stat-item">
          <i class="feather icon-map-pin stat-icon location-icon"></i>
          <span class="stat-value">847</span>
          <span class="stat-label">Locations</span>
        </span>
        <span class="stat-divider"></span>
        <span class="stat-item">
          <i class="feather icon-search stat-icon detection-icon"></i>
          <span class="stat-value">1.8M</span>
          <span class="stat-label">Detections</span>
        </span>
      </div>
    </li> -->
    <!-- System Resource Badge -->
    <li class="nav-item d-none d-lg-flex align-items-center mr-50">
      <div class="navbar-resource-badge">
        <span class="resource-item" [title]="getStorageTitle()">
          <ng-container *ngIf="isCenter; else diskLabel">
            <lucide-angular name="hard-drive" [size]="16" class="resource-icon"></lucide-angular>
          </ng-container>
          <ng-template #diskLabel>
            <span class="resource-label">DISK</span>
          </ng-template>
          <span class="resource-value text-disk">{{ getStorageUsage() }}</span>
        </span>
        <span class="resource-item" [title]="getCameraTitle()">
          <ng-container *ngIf="isCenter; else cameraLabel">
            <lucide-angular name="video" [size]="16" class="resource-icon"></lucide-angular>
          </ng-container>
          <ng-template #cameraLabel>
            <span class="resource-label">CAMERA</span>
          </ng-template>
          <span class="resource-value text-camera">{{ getCameraStats() }}</span>
        </span>
        <span class="resource-item" [title]="getNetworkTitle()">
          <ng-container *ngIf="isCenter; else netLabel">
            <lucide-angular name="wifi" [size]="16" class="resource-icon"></lucide-angular>
          </ng-container>
          <ng-template #netLabel>
            <span class="resource-label">NET</span>
          </ng-template>
          <span class="resource-value">
            <lucide-angular name="arrow-down" [size]="16" class="text-success mr-25"></lucide-angular>
            {{ getRxSpeed() }}
            <lucide-angular name="arrow-up" [size]="16" class="text-primary ml-50 mr-25"></lucide-angular>
            {{ getTxSpeed() }} Mbps
          </span>
        </span>
      </div>
    </li>
  </div>
</ng-container>
